import React from 'react';
import { ButtonProps } from './interface';
import './style.scss';

export const Button: React.FC<ButtonProps> = ({ children, onClick, type, className, icon }) => {
    const buttonType = type || 'default' || 'disabled';

    return (
        <button className={`btn btn-${buttonType} ${className || ''}`} onClick={onClick}>
            {icon} {children}
        </button>
    );
}